import React, { useState } from 'react';
import Card from '../../share/cards/Card';
import { Modal } from '../../share/modal/Modal';
import AcceptIdea from './AcceptIdea';
import {
	AiOutlineCheckCircle,
	AiOutlineExclamationCircle,
} from 'react-icons/ai';
import { BtnPrimary } from '../../share/buttons/Btn';
import useFetch from '../../../Hooks/useFetch';

function IdeaTable({ getIdeas, setIdea }) {
	const [accept, setAccept] = useState(false);
	const [ideasInfoList, setIdeasInfoList] = useState([]);
	const [selectedIdea, setSelectedidea] = useState({});
	console.log('IdeaTable ~ ideasInfoList:', ideasInfoList);

	const getIdeasInfo = useFetch({
		method: 'GET',
		url: `BootCampIdeasService/11/userIdeas`,
		noHeader: false,
		trigger: true,
		setter: (data) => {
			setIdeasInfoList(data.results);
		},
	});

	const handleSelectedIdea = (id) => {
		const idea = ideasInfoList.find((item) => item.id === id);
		setSelectedidea(idea);
		setAccept(true);
	};

	return (
		<div>
			<div className=' flex SupportTicket__header justify-between items-center mt-[5rem]'>
				<h3 className=' text-[#77498F] text-[2rem] font-bold'>
					اطلاعات ایده های بوت کمپ
				</h3>
				<BtnPrimary
					text='بازگشت'
					className=' px-12 py-8 mt-6 mb-8'
					onClick={() => setIdea(false)}
				/>
			</div>
			<p className=' mt-[1.3rem] text-[#21212199] font-normal text-[1.2rem] leading-[2.4rem]'>
				با انتخاب افراد بر اساس اولویت ها و سپس فشرد دکمه ثبت گروه، میتوانید
				تیم های خود را تشکیل دهید.
			</p>
			<Card className=' grid grid-cols-[1fr_1fr_0.25fr] px-[3rem] py-[1.5rem] gap-[4rem] justify-between items-center text-[1.6rem] h-[8rem] SupportTicketTable-header mt-[1rem]'>
				{header.map((item, id) => (
					<div className='text-[#212121E5] font-bold  leading-[1.8rem] text-[1.7rem]'>
						{item.title}
					</div>
				))}
			</Card>
			{ideasInfoList?.map((item, id) => (
				<Card
					key={item.id}
					className='starttable grid grid-cols-[1fr_1fr_0.25fr] px-[3rem] py-[1.5rem] gap-[4rem] justify-between items-center text-[1.6rem] h-[8rem] SupportTicketTable-body  my-4'
				>
					<div>{item?.idea_name}</div>
					<div>{item?.user}</div>
					<div className='flex items-center justify-center '>
						<AiOutlineExclamationCircle className='cursor-pointer text-[#21212199] w-[2.4rem] text-[2.4rem] ml-[1.6rem]' />
						<AiOutlineCheckCircle
							className={
								item.is_confirmed
									? ' text-[#2E7D32] cursor-pointer w-[2.4rem] text-[2.4rem] '
									: ' cursor-pointer text-[#21212199] w-[2.4rem] text-[2.4rem] '
							}
							onClick={() => handleSelectedIdea(item?.id)}
						/>
					</div>
				</Card>
			))}{' '}
			<Modal show={accept} className=' w-[50%]'>
				<AcceptIdea
					close={setAccept}
					selectedIdea={selectedIdea}
					getIdeasInfo={getIdeasInfo}
				/>
			</Modal>
		</div>
	);
}

export default IdeaTable;

const header = [{ title: ' نام ایده' }, { title: 'نام کاربر' }, { title: '' }];
